/* menu配置文件
 * routerFirst: header对应的一级菜单
 * submenu: 每个一级菜单下对应的左侧menu 每个对象对应一个三级菜单 如：数据概览、用户探索
 * key: 用作路由跳转
 * authorizeName: 对应授权 （为兼容老系统，一个页面可能对应多个关键词，反之亦存在。具体参照new-old-compare.js）
 */
const navMenu = [
  {
    routerFirst: 'dashboard',
    submenu: [],
  },
  {
    routerFirst: 'gameReport',
    submenu: [],
  },
  {
    routerFirst: 'analytics',
    submenu: [
      {
        key: '/analytics/overview',
        menuIcon: 'icon-overview',
        menuTitle: 'nav.overview.title',
        opened: true,
        shown: false,
        actived: false,
        menuItems: [{
          key: '/analytics/overview/app',
          title: 'nav.overview.app',
          authorizeName: ['summarize'],
          shown: false,
          actived: false,
        }, {
          key: '/analytics/overview/trend',
          title: 'nav.overview.trend',
          authorizeName: ['newUserStartup', 'activeAnalysis'],
          shown: false,
          actived: false,
        }, {
          key: '/analytics/overview/channel',
          title: 'nav.overview.channel',
          authorizeName: ['partnerData', 'channelAnalysis', 'channelCopy'],
          shown: false,
          actived: false,
        }, {
          key: '/analytics/overview/keepuser',
          title: 'nav.overview.keep',
          authorizeName: ['keepInfoCustom', 'keepInfoStandard'],
          shown: false,
          actived: false,
        }, {
          key: '/analytics/overview/scene',
          title: 'nav.overview.scene',
          authorizeName: ['smallProgramScene'],
          shown: false,
          actived: false,
          appletRelated: true,
        }, {
          key: '/analytics/overview/scan',
          title: 'nav.overview.scan',
          authorizeName: ['smallProgramScan'],
          shown: false,
          actived: false,
          appletRelated: true,
        }, {
          key: '/analytics/overview/share',
          title: 'nav.overview.share',
          authorizeName: ['smallProgramShare'],
          shown: false,
          actived: false,
          appletRelated: true,
        }, {
          key: '/analytics/overview/quality',
          title: 'nav.overview.quality',
          authorizeName: ['userQualityAccess'],
          shown: false,
          actived: false,
        }],
      }, {
        key: '/analytics/user',
        menuIcon: 'icon-usersearch',
        menuTitle: 'nav.user.title',
        opened: true,
        shown: false,
        actived: false,
        menuItems: [{
          key: '/analytics/user/userPortrait',
          title: 'nav.user.portrait',
          authorizeName: ['userPortrait'],
          shown: false,
          actived: false,
        }, {
          key: '/analytics/user/group',
          title: 'nav.user.group',
          authorizeName: ['userGroup'],
          shown: false,
          actived: false,
        }],
      }, {
        key: '/analytics/behavior',
        menuIcon: 'icon-behavior',
        menuTitle: 'nav.behavior.title',
        opened: true,
        shown: false,
        actived: false,
        menuItems: [{
          key: '/analytics/behavior/page',
          title: 'nav.behavior.page',
          authorizeName: ['pageInfo'],
          shown: false,
          actived: false,
        }, {
          key: '/analytics/behavior/events',
          title: 'nav.behavior.event',
          authorizeName: ['eventData', 'eventDetail'],
          shown: false,
          actived: false,
        }, {
          key: '/analytics/behavior/funnel',
          title: 'nav.behavior.funnel',
          authorizeName: ['eventData'],
          shown: false,
          actived: false,
        }, {
          key: '/analytics/behavior/smart-scan',
          title: 'nav.behavior.flexible',
          authorizeName: ['eventCloud'],
          shown: false,
          actived: false,
        }],
      }, {
        key: '/analytics/business',
        menuIcon: 'nav-shopping',
        menuTitle: 'nav.business.title',
        opened: true,
        shown: false,
        actived: false,
        menuItems: [{
          key: '/analytics/business/transaction',
          title: 'nav.business.transaction',
          authorizeName: ['transaction'],
          shown: false,
          actived: false,
        }, {
          key: '/analytics/business/purchase',
          title: 'nav.business.purchase',
          authorizeName: ['purchase'],
          shown: false,
          actived: false,
        }],
      }, {
        key: '/analytics/exploration',
        menuIcon: 'icon-explore',
        menuTitle: 'nav.exploration.title',
        opened: true,
        shown: false,
        actived: false,
        menuItems: [{
          key: '/analytics/exploration/overview',
          title: 'nav.exploration.title',
          authorizeName: ['timeRangeAnalysis', 'countryDistribution',
            'provinceDistribution', 'versions', 'userMobiles',
            'userPixel', 'userOs', 'userOperators',
            'userNetworking', 'loseUser', 'loseFunnel', 'userReturn',
            'userStartup', 'useInterval', 'useTime', 'jailbroken'],
          shown: false,
          actived: false,
        },{
          key: '/analytics/exploration/event',
          title: 'nav.exploration.eventTitle',
          authorizeName: ['eventExploration'],
          shown: false,
          actived: false,
        }],
      },
    ],
  },
  {
    routerFirst: 'helper',
    submenu: [
      {
        key: '/helper/err',
        menuIcon: 'icon-errorreport',
        menuTitle: 'nav.err.report',
        opened: true,
        shown: false,
        actived: false,
        menuItems: [
          {
            key: '/helper/err/info',
            title: 'nav.err.analytics',
            authorizeName: ['exception'],
            shown: false,
            actived: false,
          }, {
            key: '/helper/err/list',
            title: 'nav.err.list',
            authorizeName: ['exceptionList', 'exceptionDetail'],
            shown: false,
            actived: false,
          },
        ],
      }, {
        key: '/helper/exportLog',
        menuIcon: 'icon-download',
        menuTitle: 'nav.exportLog',
        opened: true,
        shown: false,
        actived: false,
        menuItems: [
          // {
          //   key: '/helper/exportLog/overview',
          //   title: 'nav.exportLog',
          //   authorizeName: ['exportLog', 'exportLogList'], // todo
          //   shown: false,
          //   actived: false,
          // },
          {
            key: '/helper/exportData/main',
            title: 'nav.exportData',
            authorizeName: ['exportLog', 'exportLogList'],
            shown: false,
            actived: false,
          },
        ],
      }
    ],
  },
  {
    routerFirst: 'manage',
    submenu: [
      {
        key: '/manage/overview',
        menuIcon: 'icon-settings-application',
        menuTitle: 'nav.manage.title',
        opened: true,
        shown: false,
        actived: false,
        menuItems: [
          {
            key: '/manage/overview/info',
            title: 'nav.manage.info',
            authorizeName: ['essentialInformation'],
            shown: false,
            actived: false,
          }, {
            key: '/manage/overview/channel',
            title: 'nav.manage.channel',
            authorizeName: ['partnerManage'],
            shown: false,
            actived: false,
          }, {
            key: '/manage/overview/event',
            title: 'nav.manage.event',
            authorizeName: ['eventManage', 'eventLabelManage'],
            shown: false,
            actived: false,
          },
          // {
          //   key: '/manage/overview/warn',
          //   title: 'nav.manage.warn',
          //   authorizeName: ['warningCenter'],
          //   shown: false,
          //   actived: false,
          // },
          {
            key: '/manage/overview/version',
            title: 'nav.manage.edition',
            authorizeName: ['versionManage'],
            shown: false,
            actived: false,
          }, {
            key: '/manage/overview/openapi',
            title: 'nav.manage.data',
            authorizeName: ['openApi'],
            shown: false,
            actived: false,
          }, {
            key: '/manage/overview/qrcode',
            title: 'nav.manage.qrcode',
            authorizeName: ['qrcodeManage'],
            shown: false,
            actived: false,
            appletRelated: true,
          }, {
            key: '/manage/overview/subscription',
            title: 'nav.manage.subscription',
            authorizeName: ['subscription', 'subscriptionEdit'], // todo
            shown: false,
            actived: false,
          }, /* {
            // 报表备注
            key: '/manage/overview/reportnotes',
            title: 'nav.manage.data',
            authorizeName: ['reportNotes'],
            shown: false,
          },*/
        ],
      },
    ],
  },
  {
    routerFirst: 'account',
    submenu: [
      {
        key: '/account/main',
        menuIcon: 'icon-authorization',
        menuTitle: 'nav.account.title',
        opened: true,
        shown: true,
        actived: false,
        menuItems: [
          {
            key: '/account/main/index',
            title: 'nav.account.title',
            authorizeName: ['authorizeAccount'],
            shown: true,
            actived: false,
          },
        ],
      },
    ],
  },
];

export default navMenu;
